/* eslint-disable class-methods-use-this */
import { Requests } from '@nx-smartmonkey/shared/helpers';

import { WeatherForecast } from '../../domain/weather/WeatherForecast';
import { WeatherForecastMapper } from '../../mappers/WeatherForecastMapper';
import { SessionRepository } from '../session/SessionRepository';
import { WeatherRepository } from './WeatherRepository';

export class WeatherRepositoryApi implements WeatherRepository {
  constructor(private requests: Requests, private sessionRepository: SessionRepository) {}
  async retrieveForecast(): Promise<WeatherForecast[]> {
    const response = await this.requests.get({
      uri: `/drivers/v3/weather_forecast`,
      params: {},
      headers: await this.sessionRepository.getAuthenticationHeader(),
    });

    return response.data.map(WeatherForecastMapper.toDomain);
  }
}
